import { createAction } from '@reduxjs/toolkit';

export const REMOVE_ALL_NOTIFICATION = 'REMOVE_ALL_NOTIFICATION';

export const removeAllNotification = createAction(
    REMOVE_ALL_NOTIFICATION,
    () => ({ payload: [] }),
);
